<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // Crime
        b-col(md="6")
          b-form-group(:label="$t('label.crime')", :label-for="$t('label.crime')")
            validation-provider(:name="$t('label.crime')", rules="required", v-slot="{ errors }")
              b-form-input(
                id="name",
                v-model="data.name",
                trim,
                :placeholder="$t('placeholder.crimeName')"
              )
              small(class="text-danger") {{ errors[0] }}

      b-row
        // Law Number
        b-col(md="2")
          b-form-group(:label="$t('label.lawNumber')", :label-for="$t('label.lawNumber')")
            b-form-input(
              v-model="data.lawNumber",
              trim,
              :placeholder="$t('placeholder.lawNumber')"
            )
        
        // Law Name
        b-col(md="6")
          b-form-group(:label="$t('label.lawName')", :label-for="$t('label.lawName')")
            b-form-input(
              v-model="data.law",
              trim,
              :placeholder="$t('placeholder.lawName')"
            )

        // Article
        b-col(md="2")
          b-form-group(:label="$t('label.article')", :label-for="$t('label.article')")
            b-form-input(
              v-model="data.article",
              trim,
              :placeholder="$t('placeholder.article')"
            )

        // Number
        b-col(md="2")
          b-form-group(:label="$t('label.number')", :label-for="$t('label.number')")
            b-form-input(
              v-model="data.number",
              trim,
              :placeholder="$t('placeholder.number')"
            )

      b-row
        // Description
        b-col(md="12")
          b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
            b-form-input(
              id="description",
              v-model="data.description",
              trim,
              :placeholder="$t('placeholder.crime_description')"
            )

      // Button
      b-row
        b-col(cols="12", class="text-right")
          b-button(
            variant="success",
            :disabled="isSubmitting",
            @click="validateAndSubmit"
          )
            | {{ $t('message.submit') }}

  audit-log-table(
    v-if="isEdit && data",
    :history="data.history || []",
    :field-translations="{ name: $t('label.crime'), description: $t('label.description'), lawNumber: $t('label.lawNumber'), law: $t('label.lawName'), article: $t('label.article'), number: $t('label.number') }"
  )
</template>

<script>
// eslint-disable-next-line import/extensions
import { ref, toRefs } from '@vue/composition-api/dist/vue-composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import vSelect from 'vue-select'
import AuditLogTable from '@/components/AuditLogTable.vue'

export default {
  name: 'Form',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
    AuditLogTable,
  },

  props: {
    data: { type: Object, required: true },
    isSubmitting: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { showErrorMessage } = useNotifications()
    const form = ref(null)

    const validateCrime = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validateCrime()
      .then(() => emit('submit', toRefs(props.data)))
      .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    return {
      required,
      form,
      validateAndSubmit,
    }
  },
}
</script>

<style scoped>

</style>
